import { Injectable } from '@angular/core';
import { InstallationData, BaseDataObject, MeterDataObject, OldMeterData } from '../../facilities-form/facilities-form.domain';
import { Observable } from 'rxjs';
import { FacilityFormTypes } from '../../../constants/app.constants';
import { BaseFacilityService } from './base-facility.service';
import { mergeMap } from 'rxjs/operators';
import { PowerFacilityService } from './power-facility.service';
import { WaterFacilityService } from './water-facility.service';
import { GasFacilityService } from './gas-facility.service';
import { HeatingFacilityService } from './heating-facility.service';

@Injectable({
  providedIn: 'root',
})
export default class FacilityServiceStrategy {
  private facilityServiceMap: { [type: string]: BaseFacilityService };

  constructor(
    powerFacilityService: PowerFacilityService,
    waterFacilityService: WaterFacilityService,
    gasFacilityService: GasFacilityService,
    heatingFacilityService: HeatingFacilityService
  ) {
    this.facilityServiceMap = {
      [FacilityFormTypes.Power.key]: powerFacilityService,
      [FacilityFormTypes.Water.key]: waterFacilityService,
      [FacilityFormTypes.Gas.key]: gasFacilityService,
      [FacilityFormTypes.Heating.key]: heatingFacilityService,
    };
  }

  public saveInstallation(
    installationType: string,
    installationId: string,
    installationData: InstallationData,
    hasMeter: boolean,
    hasAdditionalData: boolean,
    hasOldMeter: boolean,
    technicalData: {
      baseData: BaseDataObject[];
      meterData?: MeterDataObject[];
      oldMeterData?: MeterDataObject[];
    }
  ): Observable<any> {
    const service = this.facilityServiceMap[installationType];

    let request = service.saveInstallation(installationId, installationData, technicalData.baseData);
    if (hasMeter) {
      request = request.pipe(mergeMap(() => service.saveMeterData(technicalData.meterData, installationId)));
    }
    if (hasOldMeter) {
      request = request.pipe(mergeMap(() => service.saveOldMeterData(technicalData.oldMeterData, installationId)));
    }

    if (hasAdditionalData) {
      request = request.pipe(mergeMap(() => service.saveAdditionalData(technicalData, installationId)));
    }

    return request;
  }
}
